export default __webpack_public_path__ + "static/media/traceify-icon.9e059719.png";